import { Component, Input, ViewChild } from '@angular/core';
import { PanelExpandableComponent } from '@app/shared/ux/panel-expandable/panel-expandable.component';
import { PolicyProductIdEnum, PurchasedProductInterface } from 'outshared-lib';
import { PanelExpandableModule } from '@app/shared/ux/panel-expandable/panel-expandable.module';
import { AsyncPipe, NgIf } from '@angular/common';
import { InsuranceEndDateProductFormComponent } from './insurance-end-date-product-form';
import { InsuranceEndProductDataComponent } from './insurance-end-product-data';
import { InsuranceEndProductFormComponent } from './insurance-end-product-form';
import { InsuranceEndProductVehicleFormComponent } from './insurance-end-product-vehicle-form';
import { WucBalloonModule, WucDisplayFieldModule } from '@inshared/website-ui-components';
import { Observable } from 'rxjs';
import { IntersectionObserverService } from '@app/core/services/intersection-observer.service';

@Component({
    standalone: true,
    selector: 'ins-insurance-end-product',
    templateUrl: './insurance-end-product.component.html',
    imports: [
        InsuranceEndDateProductFormComponent,
        InsuranceEndProductDataComponent,
        InsuranceEndProductFormComponent,
        InsuranceEndProductVehicleFormComponent,
        NgIf,
        PanelExpandableModule,
        WucDisplayFieldModule,
        AsyncPipe,
        WucBalloonModule,
    ],
})
export class InsuranceEndProductComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    @ViewChild(PanelExpandableComponent, { static: true }) endProductForm: PanelExpandableComponent;
    @ViewChild(PanelExpandableComponent, { static: true }) endDateProductForm: PanelExpandableComponent;

    public isScreenSmall$: Observable<boolean> = this.intersectionObserverService.isScreenSmall$;

    constructor(private intersectionObserverService: IntersectionObserverService) {
    }

    public get isVehicle(): boolean {
        return Boolean(
            [PolicyProductIdEnum.Car, PolicyProductIdEnum.Moped, PolicyProductIdEnum.Motorcycle].includes(
                this.purchasedProduct.productId
            )
        );
    }
}
